import React, { useState } from "react";
import {
  Container,
  InputGroup,
  Row,
  Col,
  Modal,
  Button,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { showModal, showSpinner } from "./../../Slices/sessionSlice";
import { editSlot, deleteSlot } from "./../../Slices/candidateSlice";
import TaskSearch from "../../components/TaskSearch/TaskSearch";
import ProjectSearchBar from "../../components/ProjectSearchBar/ProjectSearchBar";
import SupervisingClientSearchBar from "../../components/SupervisingClientSearchBar/SupervisingClientSearchBar";
import SpinnerButton from "../../components/SpinnerButton/SpinnerButton";
import TimePicker from "../../components/TimePicker/TimePicker";
import { calculateDuration } from "../../helpers/stubs";
import { id as splitSlotId } from "../../containers/SplitSlot/SplitSlot";
import moment from "moment";

//#region CONSTANTS
export const id = "EDIT_SLOT";
const editSlotSaveId = "editSlot.save";
const editSlotDeleteId = "editSlot.delete";
//#endregion

function EditSlot(props) {
  // need to be fetched from sessionSlice
  const candidateId = "61dc087d2625b634c8aae6a5";

  const { data } = props;
  const initialFromTime = data.slotFrom;
  const initialToTime = data.slotTo;

  //#region Store Listeners
  const dispatch = useDispatch();
  const { selectedTask, selectedProject, selectedClient, sessionUser } =
    useSelector((state) => state.sessionSlice);
  //#endregion

  //#region State
  const [from, setFrom] = useState(data.slotFrom || null);
  const [to, setTo] = useState(data.slotTo || null);
  const [warning, setWarning] = useState(null);
  //#endregion

  //#region Validation for fields
  const noEmptyFields = () => {
    if (
      selectedTask.length === 0 ||
      selectedProject.length === 0 ||
      selectedClient.length === 0 ||
      !from ||
      !to
    ) {
      return true;
    }
    return false;
  };
  //#endregion
  //#region Validate Entered Slot From and Slot To
  const validateEditSlot = () => {
    if (from) {
      if (moment(from).isBefore(initialFromTime, "minutes")) {
        console.log("from time is before");
        setWarning(true);
        setTimeout(() => {
          setWarning(false);
        }, 5 * 1000);
        return;
      }
    }
    if (to) {
      if (moment(to).isAfter(initialToTime, "minutes")) {
        console.log("to time is after");
        setWarning(true);
        setTimeout(() => {
          setWarning(false);
        }, 5 * 1000);
        return;
      }
    }
    const payload = {
      slotFrom: from,
      slotTo: to,
      slotId: data._id,
      userId: sessionUser._id,
      taskName: selectedTask[0].name,
      supervisingClientId: selectedClient[0]._id,
      projectId: selectedProject[0]._id,
    };
    dispatch(showSpinner({ id: editSlotSaveId }));
    dispatch(editSlot(payload));
  };
  //#endregion
  return (
    <>
      <Modal
        show={true}
        onHide={() => {
          dispatch(showModal(null));
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Session</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="inputGroup-sizing-default">
                    Task Name
                  </InputGroup.Text>
                  <Col sm="10">
                    <TaskSearch />
                  </Col>
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col sm="1" className="align-middle">
                <div className="align-middle">From</div>
              </Col>
              <Col sm="2" className="">
                <TimePicker
                  getSelectedTime={(e) => setFrom(e)}
                  label="from"
                  placeHolderTime={initialFromTime}
                  date={moment(initialFromTime).format("YYYY-MM-DD ")}
                />
              </Col>
              <Col sm="1" className="align-middle">
                <span className="align-middle">To</span>
              </Col>
              <Col sm="2" className="">
                <TimePicker
                  getSelectedTime={(e) => setTo(e)}
                  label="to"
                  placeHolderTime={initialToTime}
                  date={moment(initialFromTime).format("YYYY-MM-DD ")}
                />
              </Col>
              <Col sm="4">
                <div className="align-bottom p-2">
                  {from && to && (
                    <span>{`period :- ${calculateDuration(from, to)}`}</span>
                  )}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="edit-position">Project</InputGroup.Text>
                  <ProjectSearchBar />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="edit-position">Client</InputGroup.Text>
                  <SupervisingClientSearchBar />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              {warning && (
                <div className="text-start mt-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="red"
                    className="bi bi-exclamation-triangle"
                    viewBox="0 0 16 16"
                  >
                    <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
                    <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" />
                  </svg>
                  <span className="">
                    {" "}
                    Entered Time Should Be Between Or Same As Slot From and To
                    Time
                  </span>
                </div>
              )}
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Row style={{ width: "100%" }}>
            <Col sm="8" className="text-start">
              <SpinnerButton
                variant="outline-danger"
                onClick={() => {
                  dispatch(showSpinner({ id: editSlotDeleteId }));
                  dispatch(deleteSlot({ slotId: data._id }));
                }}
                name="Delete Slot"
                disabled={false}
                id={editSlotDeleteId}
              />
            </Col>
            <Col sm="2" className="text-end">
              <Button
                variant="outline-primary"
                onClick={() => {
                  dispatch(
                    showModal({
                      id: splitSlotId,
                      data: {
                        slotFrom: data.slotFrom,
                        slotTo: data.slotTo,
                        slotId: data._id,
                      },
                    })
                  );
                }}
              >
                Split Slot
              </Button>
            </Col>
            <Col sm="2">
              <SpinnerButton
                variant="outline-primary"
                id={editSlotSaveId}
                disabled={noEmptyFields()}
                onClick={validateEditSlot}
                name="Save"
              />
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default EditSlot;
